import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSuperscript: React.FC<CentralIconBaseProps> = (props) => {
  return (
    <CentralIconBase {...props} ariaLabel="superscript">
      <path
        d="M3 6L13 18M13 6L3 18"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
      />
      <path
        d="M17 11.0006H16V12.0006H17V11.0006ZM21 12.0006H22V10.0006H21V12.0006ZM17 12.0006H21V10.0006H17V12.0006ZM19.0052 5C19.5643 5 20 5.37369 20 6.04969H22C22 4.25551 20.6552 3 19.0052 3V5ZM20 6.04969C20 6.29665 19.9103 6.50062 19.6654 6.7473C19.3862 7.02844 18.9949 7.27757 18.4641 7.61445C17.5669 8.18394 16 9.11704 16 11.0006H18C18 10.3836 18.4331 10.003 19.5359 9.30304C20.0051 9.0052 20.6138 8.63068 21.0846 8.15642C21.5897 7.64769 22 6.96449 22 6.04969H20ZM18.0108 6.08062C18.0674 5.38017 18.4791 5 19.0052 5V3C17.164 3 16.134 4.47668 16.0173 5.91938L18.0108 6.08062Z"
        fill="currentColor"
      />
    </CentralIconBase>
  );
};

export default IconSuperscript;
